import { HttpClient } from '@angular/common/http';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader } from '@ngx-translate/core';
import { environmentCore } from '@core-lib/environments';
import { mergeRecursive } from '@core-lib/functions/utils.function';
import { ITranslationFileParam } from '@core-lib/models';
import { of, forkJoin } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';
import * as i18nCoreFilenames from '@shared-assets/i18n/_i18nmappings';
import * as i18nAppFilenames from '@assets/i18n/_i18nmappings';

// Imports from current app's aliases
import { environment } from '@environments/environment';

export function TranslateLoaderFactory(http: HttpClient): MultiTranslateHttpLoader {
	return new MultiTranslateHttpLoader(http);
}

export class MultiTranslateHttpLoader implements TranslateLoader {
	resources: ITranslationFileParam[] = [];

	constructor(private http: HttpClient, resources: ITranslationFileParam[] = []) {
		// Current app's translation files
		const appFiles = i18nAppFilenames.mappings.map(f => {
			return {
				prefix: `${environment.assetsPath}/i18n/${f}.`,
				suffix: `.json?v${environment.appVersion}`
			};
		});

		// Shared translation files
		const coreFiles = i18nCoreFilenames.mappings.map(f => {
			return {
				prefix: `${environmentCore.sharedAssetsPath}/i18n/${f}.`,
				suffix: `.json?v${environment.appVersion}`
			};
		});

		this.resources = [...appFiles, ...coreFiles];
	}

	getTranslation(lang: string): any {
		// Load and merge each translation files
		return of(this.resources.map(resourceName => this.http.get(`${resourceName.prefix}${lang}${resourceName.suffix}`))).pipe(
			mergeMap(calls => forkJoin(calls)),
			map(responses => responses.reduce((a, b) => mergeRecursive(a, b)))
		);
	}
}

export class AppMissingTranslationHandler implements MissingTranslationHandler {
	handle(params: MissingTranslationHandlerParams): string {
		const message = '🚫 Missing translation for : ' + params.key + ' 🚫';
		console.warn(message);
		return message;
	}
}
